import React, { useMemo, useState, useEffect } from "react";

import { Select } from "antd";
// import { MdAdd } from "react-icons/md";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useContext } from "react";
import ConstituencyContext from "../../../context/constituencyContext";
import ConstituencyInfo from "../ConstituencyInfo";
import { useTranslation } from "react-i18next";
import VillageData from "../VillageInfo";
import AssemblyData from "./AssemblyInfo";

import ConstituencyData from "../ConstituencyInformation";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import { useQuery } from "react-query";

const Parliamentary = ({ constituencyData, loading }) => {
  const axiosInstance = useAxiosInstance();
  const { t } = useTranslation();

  const [selectedMarker, setSelectedMarker] = useState({});
  const [electionYears, setElectionYears] = useState([]);
  // const [yearSelected, setYearSelected] = useState("");
  const [year, setYear] = useState();
  const [previousYear, setPreviousYear] = useState();
  const constituencyContext = useContext(ConstituencyContext);
  const handleModal = () => {
    constituencyContext.updateOpenModal(true);
  };

  const constituencyId = constituencyData ? constituencyData._id : null;

  const getIsDataAvailable = (summaryData) => {
    const checkAvailability = (key) =>
      ["YES", "Yes"].includes(summaryData[key]);

    return (
      checkAvailability("Form 20") &&
      checkAvailability("Electoral Roll") &&
      checkAvailability("PS Village Mapping Data") &&
      checkAvailability("Village Data")
    );
  };
  // API request function
  const fetchConstituencyByState = async (id, year) => {
    return axiosInstance.get(
      `api/parliment/getParlimentsummaryById/${id}?year=${year}`
    );
  };

  // Query using react-query
  const queryData = useQuery(
    ["summary-data", constituencyId, year],
    () => {
      if (constituencyId && year) {
        return fetchConstituencyByState(constituencyId, year);
      } else {
        // Return a resolved promise with null data
        return Promise.resolve(null);
      }
    },
    {
      refetchOnWindowFocus: false,
      retry: 1
    }
  );

  // Access the data from the query response
  const summaryData = queryData?.data?.data?.data || {};
  const isDataAvailable = getIsDataAvailable(summaryData);

  const fetchConstituencyTableById = async (constituencyId, year) => {
    if (constituencyId && year) {
      // Check if both constituencyId and year are defined
      return axiosInstance.get(
        `api/parliment/getParlimentTableById/${constituencyId}?years=${year}`
      );
    } else {
      return null;
    }
  };

  const constituencyTableData = useQuery(
    ["client-constituency-table", constituencyId, year],
    () => fetchConstituencyTableById(constituencyId, year),
    {
      enabled: constituencyId !== undefined && year !== undefined,
      refetchOnWindowFocus: false,
      retry: 1
    }
  );
    
  const constituencyDataList = constituencyTableData?.data?.data?.data;
  const constituencyLoading = constituencyTableData?.isLoading;

  // console.log(constituencyTableData?.data?.data?.data?.villageData )

  const center = useMemo(() => {
    return (constituencyTableData?.data?.data?.data?.assemblyWinners || []).map(
      (village) => {
        if (village !== null && village?.location != null) {
          const parts = village?.location.split(", ");

          // Extract latitude and longitude values
          const lat = parseFloat(parts[0].split(":")[1].trim());
          const long = parseFloat(parts[1].split(":")[1].trim());

          return {
            lat: +lat,
            lng: +long,
            title: village?.assemblyName,
            village_id: village?.assemblyId,
            winnerParty: village?.winner,
            runnerUpParty: village?.runnerUp,
            firstRunnerUpParty: village?.firstRunnerUp
          };
        } 
        else if ((village !== null && village?.location) === null) {
          return {
            lat: 28.7041,
            lng: 77.1025, //delhi coordinate if lat lng not available
            title: village?.assemblyName,
            village_id: village?.assemblyId,
            winnerParty: village?.winner,
            runnerUpParty: village?.runnerUp,
            firstRunnerUpParty: village?.firstRunnerUp
          };
        } 
        else {
          return null;
        }
      }
    );
  }, [constituencyTableData]);

  useEffect(() => { 
    if (constituencyId) {
      const fetchElectionYears = async () => {
        try {
          const response = await axiosInstance.get(
            `api/parliment/getElectionYearsById/${constituencyId}`
          );
          setElectionYears(response.data);
          // setYear(response.data?.data?.electionYears[0]);
          if (response.data?.data?.electionYears.length > 0) {
          const latestYear = Math.max(...response.data?.data?.electionYears);
          setYear(latestYear);
        }
        } catch (error) {
          console.error(error);
        }
      };

      fetchElectionYears();
    }
  }, [constituencyId]);

  useEffect(() => {
  if (electionYears?.data?.electionYears?.length > 1 && year) {
    const sortedYears = [...electionYears.data.electionYears].sort((a, b) => b - a);
    const currentIndex = sortedYears.indexOf(year);
    if (currentIndex !== -1 && currentIndex < sortedYears.length - 1) {
      setPreviousYear(sortedYears[currentIndex + 1]);
    } else {
      setPreviousYear(undefined); // No previous year
    }
  } else {
    setPreviousYear(undefined); // Not enough years to determine previous
  }
}, [year, electionYears]);

// console.log("Previous year",previousYear)

  const fetchVillageTableById = async (id, year) => {
    return axiosInstance.get(
      `api/parliment/getVillageTableById/${id}?years=${year}`
    );
  };
  // console.log("selectedMarker",selectedMarker)
  const queryVillageData = useQuery(
    ["village-data", selectedMarker?.village_id, year],
    () => fetchVillageTableById(selectedMarker?.village_id, year),
    {
      refetchOnWindowFocus: false,
      enabled: selectedMarker?.village_id !== undefined && year !== undefined,
      retry: 1
    }
  );

  const fetchPrevYearConstituencyTableById = async (constituencyId, year) => {
    if (constituencyId && year) {
      // Check if both constituencyId and year are defined
      return axiosInstance.get(
        `api/parliment/getParlimentTableById/${constituencyId}?years=${year}`
      );
    } else {
      return null;
    }
  };
  const prevConstituencyTableData = useQuery(
      ["client-constituency-table", constituencyId,previousYear],
      () => fetchPrevYearConstituencyTableById(constituencyId,previousYear),
      {
        enabled: constituencyId !== undefined && previousYear !== undefined,
        refetchOnWindowFocus: false,
        retry: 1
      }
  );

  const currVillageName = selectedMarker?.title;

  // Find matching village from previous year by name
  const prevVillage = (prevConstituencyTableData?.data?.data?.data?.assemblyWinners || []).find(
    v => v?.assemblyName === currVillageName
  );

  const prevVillageId = prevVillage?._id || null;

  const prevYearVillageData=useQuery(
    ["prev-village-data", prevVillageId, previousYear],
    () => fetchVillageTableById(prevVillageId, previousYear),
    {
      refetchOnWindowFocus: false,
      enabled: prevVillageId !== null && prevVillageId!==undefined && previousYear !== undefined,
      retry: 1
    }
  );
  const prevVillageFetchedElectoralData = prevYearVillageData?.data?.data?.data?.electoralData;

  const villageLoading = queryVillageData?.isLoading;

  const villageFetchedData = queryVillageData?.data?.data?.data;
  const villagesList = constituencyTableData?.data?.data?.data?.assemblyWinners;

  const handleVillageSelectChange = (id) => {
    const newMarker = center.find((item) => item?.village_id === id);
    if (newMarker) {
      setSelectedMarker(newMarker);
    }
  };

  useEffect(() => {
    if (center.length > 0) {
      setSelectedMarker(center[0]);
    }
  }, [JSON.stringify(center)]);

  return (
    <>
      <div className='view-constituency'>
        <div className='flex items-center justify-between mt-5'>
          <div className='constituency-name'>
            <p>
              {constituencyData?.name || "NA"}{" "}
              <span className='mr-2 pl-1'> ({t("Parliament")}) {constituencyData?.district || "NA"},
                <span> {constituencyData?.state || "NA"} </span>
              </span>
              <InfoCircleOutlined onClick={handleModal} />
            </p>
          </div>

          <div className='flex items-center mt-5'>
            <Select
              id='villageSelect'
              placeholder={t("select") + " " + t("assemblies")}
              value={selectedMarker?.village_id}
              onChange={handleVillageSelectChange}
              className='mr-4'
              showSearch // Enable showSearch
              optionFilterProp='children' // Specify the property to filter on
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >

{/* temporary updated to fix baroda constituency */}
              {(villagesList || [])
                .filter(village => village.assemblyName) // Optional: filter out unnamed villages
                .sort((a, b) => {
                  const nameA = a.assemblyName || '';
                  const nameB = b.assemblyName || '';
                  return nameA.localeCompare(nameB);
                })
                .map((village) => (
                  <Select.Option key={village?.assemblyId} value={village?.assemblyId}>
                    {village?.assemblyName || 'Unnamed Assembly'}
                  </Select.Option>
                ))}
            </Select>

            <Select
              className='mr-4'
              placeholder={t("selectYear")}
              onChange={(value) => setYear(value)}
              value={year}
            >
              {electionYears?.data?.electionYears.map((year) => (
                <Select.Option key={year} value={year}>
                  {year}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
        <div className='flex mb-3 constituency-count'>
          <p className='mr-5'>
            {t("Assemblies")}:
            <span>{constituencyDataList?.totalVillageCount} </span>
          </p>
          <p>
            {t("pollingStations")}:
            <span> {constituencyDataList?.totalPSCount}</span>
          </p>
        </div>
        <AssemblyData
          constituencyData={constituencyData}
          loading={loading}
          summaryData={summaryData}
          constituencyDataList={constituencyDataList}
          center={center}
          setSelectedMarker={setSelectedMarker}
          selectedMarker={selectedMarker}
          villageFetchedData={villageFetchedData}
          // prevVillageFetchedData={prevVillageFetchedData}
          prevVillageFetchedData={prevVillageFetchedElectoralData}
          isDataAvailable={isDataAvailable}
          isLoading={villageLoading}
          electionYears={electionYears}
          setSelectedYear={setElectionYears}
          constituencyId={constituencyId}
          year={year}
          setYear={setYear}
          previousYear={previousYear}
          setPreviousYear={setPreviousYear}
          constituencyLoading={constituencyLoading}
        />
        <ConstituencyData
          constituencyDataType={constituencyData?.type}
          summaryData={summaryData}
          constituencyDataList={constituencyDataList}
          isDataAvailable={isDataAvailable}
          isLoading={constituencyLoading}
        />
      </div>
      {constituencyContext.isOpenModal && (
        <ConstituencyInfo
          isOpen={constituencyContext.isOpenModal}
          constituencyData={constituencyData}
          constituencyDataList={constituencyDataList}
        />
      )}
    </>
  );
};

export default Parliamentary;
